import React, { useEffect } from "react"
import { StaticImage } from "gatsby-plugin-image"
import Layout from "../components/layouts/layout"
import SEO from "../components/seo"
import "./style.scss"
const contactPage = () => {

  return (
    <Layout>
      <SEO title="联系我们" description="联系我们" />
      <div id="contactWrap">
        <div className="banner">
          <StaticImage
            className="d-md-block d-none"
            loading="lazy"
            placeholder="blurred"
            src="../assets/images/banner-联系我们.png"
            quality={95}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="联系我们"
            title="联系我们"
          />
          <StaticImage
            className="d-md-none d-block"
            loading="lazy"
            placeholder="blurred"
            src="../assets/images/ydd-banner-联系我们.png"
            quality={95}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="联系我们"
            title="联系我们"
          />
        </div>
        <div className="container contactMain">
          <div className="row align-items-center">
            <div className="contactContent col-md-6 col-12">
              <div>
                <StaticImage
                  loading="lazy"
                  src="../assets/images/i-地址.png"
                  quality={95}
                  formats={["AUTO", "WEBP", "AVIF"]}
                  alt="联系我们"
                  title="联系我们"
                />
                公司地址：
                <p> 福建省福州市闽侯高新区</p>
              </div>
              <div>
                <StaticImage
                  loading="lazy"
                  src="../assets/images/i-邮箱.png"
                  quality={95}
                  formats={["AUTO", "WEBP", "AVIF"]}
                  alt="联系我们"
                  title="联系我们"
                />
                邮箱：
                <p>contact@papamk.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
export default contactPage
